import api from '@/api'
import { WITH_LOADING } from '@/store/action-types'
const GET_RSA_PKEY = 'setRsaPublicKey'
const rootTrue = Object.freeze({ root: true })

const state = function () {
  return {
    publicKey: null /** RSA public key */
  }
}

const actions = {
  fetchRsaPublicKey: ({ commit, dispatch }) => {
    const action = api.get('/public/adm/com/getRsaPublicKey').then(r => {
      commit(GET_RSA_PKEY, r.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  }
}

const mutations = {
  [GET_RSA_PKEY]: (state, data) => {
    state.publicKey = `-----BEGIN PUBLIC KEY-----\r\n${data}\r\n-----END PUBLIC KEY-----`
  }
}

const getters = {
  publicKey: state => state.publicKey
}

const rsa = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
export default rsa
